import AccountCircle from '@material-ui/icons/AccountCircle';
import CardTravelIcon from '@material-ui/icons/CardTravel';
import BusinessIcon from '@material-ui/icons/Business';
import SettingsIcon from '@material-ui/icons/Settings';
import PieChartIcon from '@material-ui/icons/PieChart';

import { Permissions } from 'utils/permissions';
import CompanyDetail from './components/company/CompanyDetail';
import Companies from './components/Companies';
import CompanyCreate from './components/company/company/CompanyCreate';
import CreateFromIntegration from './components/company/company/CreateFromIntergation';
import Dashboard from './components/Dashboard';
import Reports from './components/reports/Reports';
import Resources from './components/Resources';
import CreateUser from './components/company/partner_portal/users/CreateUser';
import EditUser from './components/company/partner_portal/users/EditUser';
import ViewUser from './components/company/partner_portal/users/ViewUser';
import AccountDetails from './components/account/details/DetailsPage';
import CreateRole from './components/company/partner_portal/roles/CreateRole';
import EditRole from './components/company/partner_portal/roles/EditRole';
import ViewRole from './components/company/partner_portal/roles/ViewRole';
import CloneRole from './components/company/partner_portal/roles/CloneRole';
import CompanyGroupsCreate from './components/company/partner_portal/groups/CreateGroup';
import CompanyGroupsEdit from './components/company/partner_portal/groups/EditGroup';
import CompanyGroupsView from './components/company/partner_portal/groups/ViewGroup';
import Integrations from './components/integrations/Integrations';
import MyProfile from './components/account/profile/MyProfile';
import SubscriptionDetail from './components/subscription/SubscriptionDetail';

export const getConfig = () => ({
    name: 'root',
    url: '/',
    children: [
        {
            name: 'subscriptions',
            url: '/subscriptions',
            label: 'Subscriptions',
            isMenu: true,
            icon: CardTravelIcon,
            component: SubscriptionDetail,
            access: {
                permission: Permissions.SUBSCRIPTION,
                type: 'view',
            },
            extra: {
                tab: 'users',
            },
            children: [
                {
                    url: '/subscriptions/:id/users',
                    component: SubscriptionDetail,
                    extra: {
                        tab: 'users',
                    },
                    access: {
                        permission: Permissions.SUBSCRIPTION_USERS,
                        type: 'view',
                    },
                },
            ],
        },
        {
            name: 'companies',
            url: '/companies',
            label: 'Companies',
            isMenu: true,
            icon: BusinessIcon,
            component: Companies,
            access: {
                permission: Permissions.COMPANIES,
                type: 'view',
            },
            children: [
                {
                    url: '/companies/create/:id',
                    component: CompanyCreate,
                    access: {
                        permission: Permissions.COMPANIES_ADD_COMPANY,
                        type: 'change',
                    },
                },
                {
                    url: '/companies/create_from/:id/:type',
                    component: CreateFromIntegration,
                    access: {
                        permission: Permissions.COMPANIES_ADD_COMPANY,
                        type: 'change',
                    },
                },
                {
                    url: '/companies/:id',
                    component: CompanyDetail,
                    access: {
                        permission: Permissions.COMPANIES,
                        type: 'view',
                    },
                    children: [
                        {
                            url: '/companies/:id/users',
                            component: CompanyDetail,
                            extra: {
                                tab: 'users',
                            },
                            access: {
                                permission: Permissions.COMPANIES_USERS,
                                type: 'view',
                            },
                        },
                        {
                            url: '/companies/:id/groups',
                            component: CompanyDetail,
                            extra: {
                                tab: 'groups',
                            },
                            access: {
                                permission: Permissions.COMPANIES_GROUPS,
                                type: 'view',
                            },
                        },
                        {
                            url: '/companies/:id/devices',
                            component: CompanyDetail,
                            extra: {
                                tab: 'devices',
                            },
                            access: {
                                permission: Permissions.COMPANIES_DEVICES,
                                type: 'view',
                            },
                        },
                        {
                            url: '/companies/:id/shares',
                            component: CompanyDetail,
                            extra: {
                                tab: 'shares',
                            },
                            access: {
                                permission: Permissions.COMPANIES_SHARES,
                                type: 'view',
                            },
                        },
                        {
                            url: '/companies/:id/vaults',
                            component: CompanyDetail,
                            extra: {
                                tab: 'vaults',
                            },
                            access: {
                                permission: Permissions.COMPANIES_VAULTS,
                                type: 'view',
                            },
                        },
                        {
                            url: '/companies/:id/policies',
                            component: CompanyDetail,
                            extra: {
                                tab: 'policies',
                            },
                            access: {
                                permission: Permissions.COMPANIES_POLICIES,
                                type: 'view',
                            },
                        },
                        {
                            url: '/companies/:id/connectors',
                            component: CompanyDetail,
                            extra: {
                                tab: 'connectors',
                            },
                            access: {
                                permission: Permissions.COMPANIES_CONNECTORS,
                                type: 'view',
                            },
                        },
                        {
                            url: '/companies/:id/backups',
                            component: CompanyDetail,
                            extra: {
                                tab: 'backups',
                            },
                            access: {
                                permission: Permissions.COMPANIES_BACKUPS,
                                type: 'view',
                            },
                        },
                        {
                            url: '/companies/:id/settings',
                            component: CompanyDetail,
                            extra: {
                                tab: 'settings',
                            },
                            access: {
                                permission: Permissions.COMPANIES,
                                type: 'view',
                            },
                        },
                        {
                            url: '/companies/:id/partner',
                            component: CompanyDetail,
                            extra: {
                                tab: 'partner',
                            },
                            access: {
                                permission: Permissions.COMPANIES,
                                type: 'view',
                            },
                            children: [
                                {
                                    url: '/companies/:id/partner/access',
                                    component: CompanyDetail,
                                    extra: {
                                        tab: 'partner',
                                        sub_tab: 'access',
                                    },
                                    access: {
                                        permission: Permissions.COMPANIES,
                                        type: 'view',
                                    },
                                },
                                {
                                    url: '/companies/:id/partner/roles',
                                    component: CompanyDetail,
                                    extra: {
                                        tab: 'partner',
                                        sub_tab: 'roles',
                                    },
                                    access: {
                                        permission: Permissions.COMPANIES,
                                        type: 'view',
                                    },
                                },
                                {
                                    url:
                                        '/companies/:id/partner/company_groups',
                                    component: CompanyDetail,
                                    extra: {
                                        tab: 'partner',
                                        sub_tab: 'company_groups',
                                    },
                                    access: {
                                        permission: Permissions.COMPANIES,
                                        type: 'view',
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    url: '/companies/:company_id/partner/access/view/:id',
                    component: ViewUser,
                    access: {
                        permission: Permissions.COMPANIES_PARTNER_USERS,
                        type: 'view',
                    },
                },
                {
                    url: '/companies/:company_id/partner/access/new',
                    component: CreateUser,
                    access: {
                        permission: Permissions.COMPANIES_PARTNER_USERS,
                        type: 'change',
                    },
                },
                {
                    url: '/companies/:company_id/partner/access/edit/:id',
                    component: EditUser,
                    access: {
                        permission: Permissions.COMPANIES_PARTNER_USERS,
                        type: 'change',
                    },
                },
                {
                    url: '/companies/:company_id/partner/roles/new',
                    component: CreateRole,
                    access: {
                        permission: Permissions.COMPANIES_PARTNER_ROLES,
                        type: 'change',
                    },
                },
                {
                    url: '/companies/:company_id/partner/roles/view/:id',
                    component: ViewRole,
                    access: {
                        permission: Permissions.COMPANIES_PARTNER_ROLES,
                        type: 'view',
                    },
                },
                {
                    url: '/companies/:company_id/partner/roles/edit/:id',
                    component: EditRole,
                    access: {
                        permission: Permissions.COMPANIES_PARTNER_ROLES,
                        type: 'change',
                    },
                },
                {
                    url: '/companies/:company_id/partner/roles/clone/:id',
                    component: CloneRole,
                    access: {
                        permission: Permissions.COMPANIES_PARTNER_ROLES,
                        type: 'change',
                    },
                },
                {
                    url: '/companies/:company_id/partner/company_groups/create',
                    component: CompanyGroupsCreate,
                    access: {
                        permission:
                            Permissions.COMPANIES_PARTNER_COMPANY_GROUPS,
                        type: 'change',
                    },
                },
                {
                    url:
                        '/companies/:company_id/partner/company_groups/view/:id',
                    component: CompanyGroupsView,
                    access: {
                        permission:
                            Permissions.COMPANIES_PARTNER_COMPANY_GROUPS,
                        type: 'view',
                    },
                },
                {
                    url:
                        '/companies/:company_id/partner/company_groups/edit/:id',
                    component: CompanyGroupsEdit,
                    access: {
                        permission:
                            Permissions.COMPANIES_PARTNER_COMPANY_GROUPS,
                        type: 'change',
                    },
                },
            ],
        },
        {
            name: 'account',
            label: 'Account',
            icon: AccountCircle,
            role: 'collapse',
            expanded: false,
            isMenu: true,
            children: [
                {
                    name: 'details',
                    label: 'Details',
                    isMenu: true,
                    access: {
                        permission: [
                            Permissions.ACCOUNT_DETAILS,
                            Permissions.ACCOUNT_DETAILS_USER_COUNTS,
                            Permissions.ACCOUNT_DETAILS_TRANSACTIONS,
                            Permissions.ACCOUNT_DETAILS_PAYMENT_METHOD,
                            Permissions.ACCOUNT_DETAILS_PAYMENT_SETTINGS,
                        ],
                        type: 'view',
                    },
                    children: [
                        {
                            url: '/account/details/summary',
                            component: AccountDetails,
                            extra: {
                                tab: 'summary',
                            },
                            access: {
                                permission: Permissions.ACCOUNT_DETAILS,
                                type: 'view',
                            },
                        },
                        {
                            url: '/account/details/user_counts',
                            component: AccountDetails,
                            extra: {
                                tab: 'user_counts',
                            },
                            access: {
                                permission:
                                    Permissions.ACCOUNT_DETAILS_USER_COUNTS,
                                type: 'view',
                            },
                        },
                        {
                            url: '/account/details/transactions',
                            component: AccountDetails,
                            extra: {
                                tab: 'transactions',
                            },
                            access: {
                                permission:
                                    Permissions.ACCOUNT_DETAILS_TRANSACTIONS,
                                type: 'view',
                            },
                        },
                        {
                            url: '/account/details/payment_method',
                            component: AccountDetails,
                            extra: {
                                tab: 'payment_method',
                            },
                            access: {
                                permission:
                                    Permissions.ACCOUNT_DETAILS_PAYMENT_METHOD,
                                type: 'view',
                            },
                        },
                        {
                            url: '/account/details/settings',
                            component: AccountDetails,
                            extra: {
                                tab: 'settings',
                            },
                            access: {
                                permission:
                                    Permissions.ACCOUNT_DETAILS_PAYMENT_SETTINGS,
                                type: 'view',
                            },
                        },
                    ],
                },
                {
                    name: 'profile',
                    label: 'My Profile',
                    isMenu: true,
                    path: '/account/profile/',
                    children: [
                        {
                            url: '/account/profile/profile',
                            component: MyProfile,
                            extra: {
                                tab: 'profile',
                            },
                        },
                        {
                            url: '/account/profile/authentication',
                            component: MyProfile,
                            extra: {
                                tab: 'authentication',
                            },
                        },
                    ],
                },
            ],
        },
        {
            name: 'reports',
            label: 'Reports',
            url: '/reports',
            icon: PieChartIcon,
            component: Reports,
            isMenu: true,
            access: {
                permission: [
                    Permissions.REPORTS_USER_ACTIVITY,
                    Permissions.REPORTS_EVENT_LOG,
                    Permissions.REPORTS_PASSWORD_ACTIVITY,
                ],
                type: 'view',
            },
        },
        {
            name: 'resources',
            label: 'Resources',
            url: '/resources',
            component: Resources,
            access: {
                permission: Permissions.RESOURCES,
                type: 'view',
            },
        },
        {
            url: '/dashboard',
            component: Dashboard,
            access: {
                permission: Permissions.DASHBOARD,
                type: 'view',
            },
        },
        {
            type: 'redirect',
            url: '/integrations',
            redirect: '/integrations/overview',
            name: 'integrations',
            label: 'Integrations',
            isMenu: true,
            icon: SettingsIcon,
            access: {
                permission: Permissions.INTEGRATIONS,
                type: 'view',
            },
            children: [
                {
                    url: '/integrations/:tab',
                    component: Integrations,
                    access: {
                        permission: Permissions.INTEGRATIONS,
                        type: 'view',
                    },
                },
            ],
        },
    ],
});
